/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SeizurePeriodDto
 */
export interface SeizurePeriodDto {
    /**
     * 
     * @type {number}
     * @memberof SeizurePeriodDto
     */
    'count'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SeizurePeriodDto
     */
    'countable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SeizurePeriodDto
     */
    'endDate': string;
    /**
     * 
     * @type {string}
     * @memberof SeizurePeriodDto
     */
    'frequencyPeriod'?: SeizurePeriodDtoFrequencyPeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof SeizurePeriodDto
     */
    'startDate': string;
}

/**
    * @export
    * @enum {string}
    */
export enum SeizurePeriodDtoFrequencyPeriodEnum {
    Year = 'YEAR',
    Month = 'MONTH',
    Day = 'DAY'
}


